<template>
  <div>
    <div v-if="!showDisabledButton && saleIsAvailable === true && orderUrl" class="flex flex-col items-start shrink-0" :class="{ 'mb-2': streamUrl }">
      <MoleculeButton
        :url="orderUrl"
        class="c-info-data-button w-full"
        :class="{ 'white-outline': theme === 'red' }"
        background-color="bg-app-primary-1-red--torch hover:bg-black"
        @click="orderClick"
      >
        {{ $t('event-detail-order-button-label') }}
      </MoleculeButton>
      <MoleculeButton :url="orderUrl" size="medium" class="c-info-data-button-mobile-sticky" background-color="bg-white" text-color="text-black" @click="orderClick">
        {{ $t('event-detail-order-button-label') }}
      </MoleculeButton>
    </div>

    <div v-if="showDisabledButton" class="flex flex-col items-start shrink-0">
      <MoleculeButton class="c-info-data-button pointer-events-none cursor-default w-full" background-color="bg-gray-300 hover:bg-gray-300" text-color="text-gray-400">
        {{ disabledButtonLabel ? $t(disabledButtonLabel) : '' }}
      </MoleculeButton>
      <MoleculeButton size="medium" class="c-info-data-button-mobile-sticky pointer-events-none cursor-default" background-color="bg-gray-300" text-color="text-gray-400">
        {{ disabledButtonLabel ? $t(disabledButtonLabel) : '' }}
      </MoleculeButton>
    </div>

    <div v-if="streamUrl" class="flex flex-col items-start shrink-0">
      <MoleculeButton
        :url="streamUrl"
        class="c-info-data-button w-full"
        background-color="bg-black hover:bg-app-primary-1-orange--bittersweet"
        text-color="text-white hover:text-white"
      >
        {{ $t('event-detail-stream-button-label') }}
      </MoleculeButton>
      <MoleculeButton :url="streamUrl" size="medium" class="c-info-data-button-mobile-sticky" background-color="bg-white" text-color="text-black">
        {{ $t('event-detail-stream-button-label') }}
      </MoleculeButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  orderUrl: { type: String, required: false, default: undefined },
  streamUrl: { type: String, required: false, default: undefined },
  saleIsAvailable: { type: Boolean, required: false, default: undefined },
  concertState: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
})

const emit = defineEmits(['orderClick'])

const mapConcertStateToLabel: Record<string, string> = {
  SOLD_OUT: 'event-detail-sold-out-button-label',
  EXPIRED: 'event-detail-expired-button-label',
  MOVED: 'event-detail-moved-button-label',
  CANCELED: 'event-detail-canceled-button-label',
}

function setDisabledButtonLabel(concertState?: Record<string, boolean>) {
  if (!concertState) {
    return undefined
  }

  if (concertState.EXPIRED) {
    return 'event-detail-expired-button-label'
  }

  if (concertState.SOLD_OUT) {
    return 'event-detail-sold-out-button-label'
  }

  const activeState = Object.keys(concertState).find((key) => concertState[key])
  return activeState ? mapConcertStateToLabel[activeState] : undefined
}

function orderClick() {
  emit('orderClick')
}

const showDisabledButton = computed(() => Object.values(props.concertState || {}).some((value) => value))
const disabledButtonLabel = computed(() => setDisabledButtonLabel(props.concertState))
</script>

<style scoped lang="scss">
.c-info-data-button {
  .i-is-stuck-on-mobile & {
    @apply hidden;
  }
}

.c-info-data-button-mobile-sticky {
  @apply hidden;

  .i-is-stuck-on-mobile & {
    @apply flex self-end;
  }
}

.white-outline {
  outline: 1px solid white;
}
</style>
